module.exports = __webpack_public_path__ + "img/AE5006-P20.c9894e16.jpg";